export const CONSTANTS = {
    CANVAS_SPACING: 64
};